import { render, staticRenderFns } from "./ActiveFiltersDisplay.vue?vue&type=template&id=922210f6&"
import script from "./ActiveFiltersDisplay.vue?vue&type=script&lang=js&"
export * from "./ActiveFiltersDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('922210f6')) {
      api.createRecord('922210f6', component.options)
    } else {
      api.reload('922210f6', component.options)
    }
    module.hot.accept("./ActiveFiltersDisplay.vue?vue&type=template&id=922210f6&", function () {
      api.rerender('922210f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipment/components/ActiveFiltersDisplay.vue"
export default component.exports